























import Vue from 'vue'
import { ActionInterface, AntrfileWithLinkElInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'AntrfileWithLinkEl',
  props: {
    templateItemData: {
      type: Object as () => AntrfileWithLinkElInterface,
      required: true
    }
  },
  methods: {
    handleActionClick (action: ActionInterface): void {
      if (action.uri !== undefined) {
        this.getView(action.view, action.content || action.uri, null, action.jumpOnCloseUri)
      }
    }
  },
  computed: {
    mainBackground (): string {
      return 'background: ' + this.templateItemData.backgroundColor + ';'
    },
    linkStyle (): string {
      return this.templateItemData.link
        ? 'color: ' + this.templateItemData.link.textColor
        : ''
    }
  }
})
